import type { MapSettingsToolsStateDataLayersAction } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.action';
import {
  activeDataLayersBTGIdPerBoundaryGroupChanged,
  setDataLayersFilter,
} from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.actionCreators';
import type { MapSettingsToolsStateDataLayersState } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.state';

export const mapSettingsToolsStateDataLayersInitialState: MapSettingsToolsStateDataLayersState = {
  activeBTGIdPerBoundaryGroup: {},
  filters: {},
};

type Action = MapSettingsToolsStateDataLayersAction;

export const mapSettingsToolsStateDataLayersReducer = (state = mapSettingsToolsStateDataLayersInitialState, action: Action): MapSettingsToolsStateDataLayersState => {
  if (setDataLayersFilter.match(action)) {
    const { boundaryGroupId, filter } = action.payload;

    return {
      ...state,
      filters: {
        ...state.filters,
        [boundaryGroupId]: filter,
      },
    };
  }

  if (activeDataLayersBTGIdPerBoundaryGroupChanged.match(action)) {
    const { boundaryGroupId, activeBTGId } = action.payload;

    return {
      ...state,
      activeBTGIdPerBoundaryGroup: {
        ...state.activeBTGIdPerBoundaryGroup,
        [boundaryGroupId]: activeBTGId,
      },
    };
  }

  return state;
};
